import { render, staticRenderFns } from "./PageSet.vue?vue&type=template&id=98f220ce&scoped=true"
import script from "./PageSet.vue?vue&type=script&lang=js"
export * from "./PageSet.vue?vue&type=script&lang=js"
import style0 from "./PageSet.vue?vue&type=style&index=0&id=98f220ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98f220ce",
  null
  
)

export default component.exports